import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';
import { BehaviorSubject, EMPTY, forkJoin, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ComponentUpsertModel, GetCompanyDatatableListModel, GetCompanyListModel, GetLicenseListModel, GetOrderListModel, ProductUpsertModel, UpsertCompanyBrandsModel, UpsertCompanyContactsModel } from 'src/models';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  params: any;
  baseURL: string = environment.HTTP;
  prodURL: string = 'https://qubeapi.com/api/central';
  private autoken :string;
  private userDetailsSubject = new BehaviorSubject<any>(null);
  userDetails$ = this.userDetailsSubject.asObservable();

  constructor(private http:HttpClient) { }

  private getSmartlockBaseURL(): string {
    return this.baseURL === this.prodURL
      ? 'https://qubeapi.com/api/central/smartlockv1'
      : `${this.baseURL}/smartlockv1`;
  }

  public login(email:any,password:any): Observable<any> 
  {
    console.log("checklogin")
    return this.http.post<any>(`${this.baseURL}/login`,{email:email,password:password});
  }

  public getCurrentUser()
  {
    return this.http.get<any>(`${this.baseURL}/profile/show`);
  }

  public getCreateRoleDetails()
  {
    return this.http.get<any>(`${this.baseURL}/role/create`);
  }

  public getEditRoleDetails(role:any)
  {
    const params = {
      role_id: role,
    };

    return this.http.get<any>(`${this.baseURL}/role/show`, {params});
  }

  public getUserRoleList()
  {
    return this.http.get<any>(`${this.baseURL}/user/create`);
  }

  public CreateUser(userdata:any)
  {
    return this.http.post<any>(`${this.baseURL}/user/store`, userdata);
  }

  public CreateRole(RoleInfo:any)
  {
    return this.http.post<any>(`${this.baseURL}/role/store`, RoleInfo);
  }

  public getEditUserProfile(UserID:any)
  {
    const params = {
      user_id: UserID,
    };

    return this.http.get<any>(`${this.baseURL}/user/edit`, { params })
  }

  public getUserProfile(UserID:any)
  {
    const params = {
      user_id: UserID,
    };

    return this.http.get<any>(`${this.baseURL}/user/show`, { params })
  }

  public getSUPERProfile(UserID:any)
  {
    const params = {
      user_id: UserID,
    };

    return this.http.get<any>(`${this.baseURL}/user/show`, { params })
  }

  public UpdateUser(userdata:any)
  {
    return this.http.post<any>(`${this.baseURL}/user/update`, userdata);
  }

  public UpdateProfile(userdata:any)
  {
    return this.http.post<any>(`${this.baseURL}/profile/update`, userdata);
  }

  public getAudit(id:any)
  {
    const params = {
      user_id: id,
    };
    return this.http.get<any>(`${this.baseURL}/user/audit`, { params })
  }

  public getAuditProfile(id:any)
  {
    const params = {
      user_id: id,
    };
    return this.http.get<any>(`${this.baseURL}/profile/audit`, { params })
  }

  public logout()
  {
    return this.http.post<any>(`${this.baseURL}/logout`,'');
  }

  public RemoveImg(id:any)
  {
    return this.http.post<any>(`${this.baseURL}/user/removeimage`,id);
  }

  public RemoveCusImg(id:any)
  {
    return this.http.post<any>(`${this.baseURL}/customer/removeimage`,id);
  }

  public GetCountryInfo()
  {
    return this.http.get<any>(`${this.baseURL}/customer/create`)
  }

  public CreateCustomer(Customerdata:any)
  {
    return this.http.post<any>(`${this.baseURL}/customer/store`, Customerdata);
  }

  public UpdateCustomer(CustomerData:any)
  {
    return this.http.post<any>(`${this.baseURL}/customer/update`, CustomerData);
  }

  public getCustomerProfile(CustomerID:any)
  {
    const params = {
      user_id: CustomerID,
    };

    return this.http.get<any>(`${this.baseURL}/customer/show`, { params })
  }

  public getCustomerEditProfile(CustomerID:any)
  {
    const params = {
      user_id: CustomerID,
    };

    return this.http.get<any>(`${this.baseURL}/customer/edit`, { params })
  }
  
  public UpdateRole(roleData:any)
  {
    return this.http.post<any>(`${this.baseURL}/role/update`, roleData);
  }

  public DelUser(id:any)
  {
    const body  = {
      user_id: id,
    };

    return this.http.post<any>(`${this.baseURL}/user/delete`,body )
  }

  public DelCus(id:any)
  {
    const body  = {
      user_id: id,
    };

    return this.http.post<any>(`${this.baseURL}/customer/delete`,body )
  }

  public Deactivate(id:any, reason:any)
  {
    const body  = {
      user_id: id,
      reason:reason
    };

    return this.http.post<any>(`${this.baseURL}/user/deactivate`,body )
  }

  public DeactivateCustomer(id:any)
  {
    const body  = {
      user_id: id,
    };

    return this.http.post<any>(`${this.baseURL}/customer/deactivate`,body )
  }

  public getRoleDetails(role:any)
  {
    const params = {
      role_id: role,
    };

    return this.http.get<any>(`${this.baseURL}/role/show`, {params});
  }

  public getRoleDetailsEdit(role:any)
  {
    const params = {
      role_id: role,
    };

    return this.http.get<any>(`${this.baseURL}/role/edit`, {params});
  }

  public deleteRole(role:any)
  {
    const body  = {
      role_id: role,
    };

    return this.http.post<any>(`${this.baseURL}/role/delete`,body )
  }

  public resetPassword(password:any, myProfileMode: boolean){
    if (myProfileMode){
      return this.http.post<any>(`${this.baseURL}/me/password`,password )
    }
    else {
      return this.http.post<any>(`${this.baseURL}/user/resetpassword`,password )
    }
  }

  public getLicenseList()
  {

    return this.http.get<any>(`${this.baseURL}/v1/license/create`);
  }

  public getLicenseCustomer(user_id:any)
  {

    return this.http.get<any>(`${this.baseURL}/v1/license/create?customer_id=${user_id}`);
  }

  public getTimezoneList()
  {

    return this.http.get<any>(`${this.baseURL}/dropdown/timezone`);
  }

  public EditSettingExpiry()
  {
    
    return this.http.get<any>(`${this.baseURL}/setting/edit`);
  }

  public UpdateSettingExpiry(data:any)
  {
    
    return this.http.post<any>(`${this.baseURL}/setting/update`, data);
  }

  public getRecipientList(page:number,item:any,sn:boolean,se:boolean,sca:boolean,sc:boolean,sortName:any)
  {
    const params:any = {
      page: page,
      item:item,
    };

    if(sortName !== '')
      {
        switch (sortName) {
        case 'name':
          params.s_name = sn;
          break;
        case 'email':
          params.s_email = se;
          break;
        case 'cdate':
          params.s_created_at = true;
          break;
        case 'contact':
          params.s_contact_no = sc;
          break;
        
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }
    
    return this.http.get<any>(`${this.baseURL}/notify-user/index`, { params });
  }

  public CreateRecipient(data:any)
  {
    
    return this.http.post<any>(`${this.baseURL}/notify-user/store`, data);
  }

  public UpdateRecipient(data: any) {

    return this.http.post<any>(`${this.baseURL}/notify-user/update`, data);
  }

  public DeleteRecipient(id:any)
  {
    const body = {
      id: id,
    };
    return this.http.post<any>(`${this.baseURL}/notify-user/delete`,body)
  }

  public CreateLicense(data:any)
  {
    
    return this.http.post<any>(`${this.baseURL}/v1/license/store`, data);
  }

  public checkDomain(data:any)
  {
    const params = {
      domain_name:data,
    };
    return this.http.get<any>(`${this.baseURL}/v1/license/domain`, {params});
  }

  public getCustomerLicenseList(custID:any,tab:any,page:any,item:any,ssystem:boolean,sdomain:boolean,sduation:boolean,sstatus:boolean,sexpt:boolean,sstore:boolean,sca:boolean,sterminal:boolean,sortName:any)
  {
    const params:any = {
      page: page,
      item:item,
      view_by:tab,
      user_id:custID
    };

    if(sortName !== '')
    {
      switch (sortName) {
      case 'system':
        params.s_system = ssystem;
        break;
      case 'domain':
        params.s_subdomain = sdomain;
        break;
      case 'status':
        params.s_status = sstatus;
        break;
      case 'duration':
        params.s_duration = sduation;
        break;
      case 'expdate':
        params.s_expiry_date = sexpt;
        break;
      case 'store':
        params.s_store_no = sstore;
        break;
      case 'terminal':
        params.s_terminal_no = sterminal;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/v1/license/index`, {params});
  }

  
  public getCustomerLicenseListV2(data: {custID:any,tab:any,page:any,rows:any, sortName:any, sortDir: any}){

    let queryParam: any = {
      page: data.page,
      item: data.rows,
      view_by: data.tab,
      user_id: data.custID,
    }

    if (data.sortName != null){
      queryParam[data.sortName] = data.sortDir
    }

    return this.http.get<any>(`${this.baseURL}/v1/license/index`, { params: queryParam })
  }

  public RevokeLicense(ID:any)
  {

    return this.http.post<any>(`${this.baseURL}/v1/license/revoke`, ID);
  }

  public SuspendLicense(ID:any)
  {

    return this.http.post<any>(`${this.baseURL}/v1/license/suspend`, ID);
  }

  // public printOrder(ID: any) {
  //   const params = {
  //     order_id: ID,
  //   };

  //   return this.http.get(`${this.baseURL}/order/print`, {params});
  // }

  public printOrder(ID: any) {
    // const params = {
    //   order_id: ID,
    // };
    const params = new HttpParams().set('order_id', ID);
    const headers = new HttpHeaders({
      'responseType': 'blob',
      'Content-Type': 'application/pdf',
    });
    //const headers = new HttpHeaders().set('Origin', 'http://multitenancy.test');
    //const headers = new HttpHeaders().set('Origin', this.baseURL);

    return this.http.get(`${this.baseURL}/order/print`,{ params, headers, responseType: 'blob' });
  }


  public getOrderdetails(id:any)
  {
    const params = {
      order_id: id,
    };

    return this.http.get(`${this.baseURL}/order/show`, {params});
  }

  public getOrderdetailsAndEdit(id:any)
  {
    const params = {
      order_id: id,
    };

    return this.http.get(`${this.baseURL}/order/edit`, {params});
  }

  public updateOrder(data:any)
  {
    return this.http.post<any>(`${this.baseURL}/order/update`, data);
  }

  public getlicenseDetails(id: any)
  {
    const params = {
      license_id: id,
    };

    return this.http.get(`${this.baseURL}/v1/license/show`, {params});
  }

  public AmendLicense(data:any)
  {
    
    return this.http.post<any>(`${this.baseURL}/v1/license/update`, data);
  }

  public ResetCustomerPassword(data:any)
  {
    return this.http.post<any>(`${this.baseURL}/customer/resetpassword`, data);
  }

  public ShowCustomerPassword(data:any)
  {
    return this.http.post<any>(`${this.baseURL}/customer/resetpassword/callback`, data);
  }

  public ForgotPasswordEmail(email:any)
  {
    const requestBody = { email };
    return this.http.post<any>(`${this.baseURL}/forgotpassword`,requestBody);
  }

  public revokeAll(id:any)
  {
    
    return this.http.post<any>(`${this.baseURL}/revokedall`,id);
  }

  public customerAudit(id:any,page:any,dateString:any)
  {
    const params:any = {
      user_id: id,
      page:page
    };

    if(dateString == 'today')
    {
      params.today = true;

    }else if(dateString == 'week')
    {
      params.week = true;
      
    }else if(dateString == 'month')
    {
      params.month = true;
    }
    else if(dateString == 'year')
    {
      params.year = true;
    }

    return this.http.get<any>(`${this.baseURL}/customer/audit`, { params })
  }

  public resetGrace(id: any, type: any, selected: any): Observable<any> {
    if (type === 'offline') {
      const requestBody = {
        "license_id": id,
        "offline_grace": selected
      };
      return this.http.post<any>(`${this.baseURL}/v1/license/grace`, requestBody);
    } else if (type === 'online') {  // Use equality operator here
      const requestBody = {
        "license_id": id,
        "online_grace": selected,
      };
      return this.http.post<any>(`${this.baseURL}/v1/license/grace`, requestBody);
    }
    // If neither 'offline' nor 'online', you might want to handle this case
    throw new Error(`Invalid type: ${type}`);
  }
  

  /////////////////////SEARCH API////////////////////////////////

  public getUserListSearchViewby(search:any,viewBy:any,item:any,sn:boolean,se:boolean,sc:boolean,ss:boolean,sr:boolean,sca:boolean,sortName:any): Observable<any> 
  {
    const params:any = {
      item:item,
      view_by:viewBy,
      search:search
    };

    if(sortName !== '')
    {
      switch (sortName) {
      case 'user':
        params.s_name = sn;
        break;
      case 'email':
        params.s_email = se;
        break;
      case 'createdBy':
        params.s_created_by = sc;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'reason':
        params.s_reason = sr;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/user/index`, { params })
  }

  public getUserList(page:number,tab:any,item:any,sn:boolean,se:boolean,sc:boolean,ss:boolean,sr:boolean,sca:boolean,sortName:any,search:any): Observable<any> 
  {
    const params:any = {
      page: page,
      item:item,
      view_by:tab,
      search:search
    };

    if(sortName !== '')
    {
      switch (sortName) {
      case 'user':
        params.s_name = sn;
        break;
      case 'email':
        params.s_email = se;
        break;
      case 'createdBy':
        params.s_created_by = sc;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'reason':
        params.s_reason = sr;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }


    return this.http.get<any>(`${this.baseURL}/user/index`, { params })
  }

  public getRoleListSearch(search:any,item:any,sr:boolean,sd:boolean,scb:boolean,sca:boolean,sortName:any): Observable<any> 
  {
    const params:any = {
      item:item,
      search:search
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'role':
        params.s_name = sr;
        break;
      case 'desc':
        params.s_description =sd ;
        break;
      case 'createdBy':
        params.s_created_by = scb;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/role/index`, { params })
  }

  public getCutomerList(page:number,tab:any,item:any,sb:boolean,sn:boolean,sl:boolean,ss:boolean,sc:boolean,sca:boolean,sortName:any,search:any): Observable<any> 
  {
    const params:any = {
      page: page,
      item:item,
      view_by:tab,
      search:search
    };

    if(sortName !== '')
    {
      switch (sortName) {
      case 'businessName':
        params.s_business = sb;
        break;
      case 'userCode':
        params.s_name = sn;
        break;
      case 'createdBy':
        params.s_created_by = sc;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'system':
        params.s_license = sl;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;  
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/customer/index`, { params })
  }

  public getCustomerListSearchViewby(search:any,viewBy:any,item:any,sb:boolean,sn:boolean,sl:boolean,ss:boolean,sc:boolean,sca:boolean,sortName:any): Observable<any> 
  {
    const params:any = {
      item:item,
      view_by:viewBy,
      search:search
    };

    if(sortName !== '')
    {
      switch (sortName) {
      case 'businessName':
        params.s_business = sb;
        break;
      case 'userCode':
        params.s_name = sn;
        break;
      case 'createdBy':
        params.s_created_by = sc;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'system':
        params.s_license = sl;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/customer/index`, { params })
  }

  public getOrderListSearchViewby(search:any,viewBy:any,item:any,sOn:boolean,scustomer:boolean,st:boolean,sOdate:boolean,ss:boolean,sca:boolean,sortName:any): Observable<any> 
  {
    const params:any = {
      view_by:viewBy,
      item:item,
      search:search
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'orderNo':
        params.s_order_no = sOn;
        break;
      case 'license':
        //params.s_ = sl;
        break;
      case 'customer':
        params.s_customer = scustomer;
        break;
      case 'type':
        params.s_order_type = st;
        break;
      case 'orderDate':
        params.s_order_date = sOdate;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/order/index`, { params })
  }

  public getOrderList(page:number,tabStatus:any,item:number,sOn:boolean,scustomer:boolean,st:boolean,sOdate:boolean,ss:boolean,sca:boolean,sortName:any,searchValue:any): Observable<any> 
  {
    const params:any = {
      page: page,
      view_by:tabStatus,
      item:item,
      search:searchValue
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'orderNo':
        params.s_order_no = sOn;
        break;
      case 'customer':
        params.s_customer = scustomer;
        break;
      case 'type':
        params.s_order_type = st;
        break;
      case 'orderDate':
        params.s_order_date = sOdate;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/order/index`, { params })
  }


  public getroleList(page:number,item:any,sr:boolean,sd:boolean,scb:boolean,sca:boolean,sortName:any,searchValue:any)
  {
    const params:any = {
      page: page,
      item:item,
      search:searchValue
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'role':
        params.s_name = sr;
        break;
      case 'desc':
        params.s_description =sd ;
        break;
      case 'createdBy':
        params.s_created_by = scb;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/role/index`, { params })
  }

  public getOrderListSearchByID(id:any,search:any,item:any,sOn:boolean,st:boolean,scd:boolean,sa:boolean,ss:boolean,scb:boolean,sca:boolean,sortName:any): Observable<any> 
  {
    const params:any = {
      user_id:id,
      item:item,
      search:search
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'orderNo':
        params.s_order_no = sOn;
        break;
      case 'createdBy':
        params.s_created_by = scb;
        break;
      case 'type':
        params.s_order_type = st;
        break;
      case 'createdDate':
        params.s_order_date = scd;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'amount':
        params.s_status = sa;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }


    return this.http.get<any>(`${this.baseURL}/order/index`, { params })
  }

  public getOrderListbyID(id:any,page:number,item:number,
    sOn:boolean,st:boolean,scd:boolean,sa:boolean,ss:boolean,scb:boolean,sca:boolean,sortName:any,searchValue:any): Observable<any> 
  {
    const params:any = {
      user_id:id,
      page: page,
      item:item,
      search:searchValue
    };
    
    if(sortName !== '')
    {
      switch (sortName) {
      case 'orderNo':
        params.s_order_no = sOn;
        break;
      case 'createdBy':
        params.s_created_by = scb;
        break;
      case 'type':
        params.s_order_type = st;
        break;
      case 'createdDate':
        params.s_order_date = scd;
        break;
      case 'status':
        params.s_status = ss;
        break;
      case 'amount':
        params.s_status = sa;
        break;
      case 'cdate':
        params.s_created_at = sca;
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }

    return this.http.get<any>(`${this.baseURL}/order/index`, { params })
  }
  
  public getEditlicenseDetails(id: any)
  {
    const params = {
      license_id: id,
    };

    return this.http.get(`${this.baseURL}/v1/license/edit`, {params});
  }

  public exportTable(data: any,who:any) 
  {
    let id: string | null = null;

    // Use a regular expression to extract the ID
    const match = who.match(/id=(\d+)/);
    if (match) {
        id = match[1]; // The captured ID is in the first group
    }
    // const id = who.searchParams.get('id'); 
    if(who == 'users')
    {
      this.params = {
        view_by:data[0],
        search:data[7],
        format:data[8]
      };
  
      if(data[6] !== '')
      {
        switch (data[6]) {
        case 'user':
          this.params.s_name = data[1];
          break;
        case 'email':
          this.params.s_email = data[2];
          break;
        case 'createdBy':
          this.params.s_created_by = data[3];
          break;
        case 'status':
          this.params.s_status = data[4];
          break;
        case 'reason':
          this.params.s_reason = data[5];
          break;
        case 'cdate':
          this.params.s_created_at = data[6];
          break;
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }
      const options = {
        params: this.params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/user/export`, options);
    }
    else if(who == 'customerlist')
    {
      this.params = {
        view_by:data[0],
        search:data[8],
        format:data[9]
      };
  
      if(data[7] !== '')
      {
        switch (data[7]) {
          case 'businessName':
            this.params.s_business = data[1];
            break;
          case 'userCode':
            this.params.s_name = data[2];
            break;
          case 'createdBy':
            this.params.s_created_by = data[3];
            break;
          case 'status':
            this.params.s_status = data[4];
            break;
          case 'system':
            this.params.s_license = data[5];
            break;
          case 'cdate':
            this.params.s_created_at = data[6];
            break;  
        }
      }
      const options = {
        params: this.params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/customer/export`, options);
    }
    else if(who == 'orderlist')
    {
      this.params = {
        view_by:data[0],
        search:data[8],
        format:data[9]
      };
  
      if(data[7] !== '')
      {
        switch (data[7]) {
        case 'orderNo':
          this.params.s_order_no = data[1];
          break;
        case 'customer':
          this.params.s_customer = data[2];
          break;
        case 'type':
          this.params.s_order_type = data[3];
          break;
        case 'orderDate':
          this.params.s_order_date = data[4];
          break;
        case 'status':
          this.params.s_status = data[5];
          break;
        case 'cdate':
          this.params.s_created_at = data[6];
          break;
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }
      const options = {
        params: this.params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/order/export`, options);
    }
    else if(who.startsWith('customer-subscription'))
    {
      
      this.params = {
        view_by:data[0],
        format:data[10],
        user_id: id 
      };

      if(data[9] !== '')
      {
        switch (data[9]) {
        case 'system':
          this.params.s_system = data[1];
          break;
        case 'domain':
          this.params.s_subdomain = data[2];
          break;
        case 'status':
          this.params.s_status = data[3];
          break;
        case 'duration':
          this.params.s_duration = data[4];
          break;
        case 'expdate':
          this.params.s_expiry_date = data[5];
          break;
        case 'store':
          this.params.s_store_no = data[6];
          break;
        case 'terminal':
          this.params.s_terminal_no = data[7];
          break;
        case 'cdate':
          this.params.s_created_at = data[8];
          break;
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }
      const options = {
        params: this.params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/v1/license/export`, options);
    } else if (who == 'namecard-list') {
        const options = {
          params: this.params,
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          responseType: 'blob' as 'json',
        };
        return this.http.get(`${this.baseURL}/e-name-cards/export?format=pdf`, options);
    } 
    else if (who == 'list'){
      const options = {
        params: data,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/v2/license/export`, options);
    }
    else{
      console.log(data, who);
      
      const options = {
        params: this.params,
        headers: new HttpHeaders({
          'Content-Type': 'application/json', // Change this if needed
        }),
        responseType: 'blob' as 'json', // Set responseType to 'blob'
      };
      return this.http.get(`${this.baseURL}/order/export`, options);
    }
  }

  public exportTableWithoutTab(data: any,who:any) 
  {
    this.params= {
      search:data[0],
      format:data[6]
    };
    
    if(data[5] !== '')
    {
      switch (data[5]) {
      case 'role':
        this.params.s_name = data[1];
        break;
      case 'desc':
        this.params.s_description =data[2] ;
        break;
      case 'createdBy':
        this.params.s_created_by = data[3];
        break;
      case 'cdate':
        this.params.s_created_at = data[4];
        break;
      default:
        // Handle any other cases or provide a default behavior if needed.
        break;
      }
    }
    
    const options = {
      params: this.params,
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // Change this if needed
      }),
      responseType: 'blob' as 'json', // Set responseType to 'blob'
    };

    return this.http.get(`${this.baseURL}/role/export`, options);
  }

  public getUserExportFormats(): Observable<any> {
    return this.http.get(`${this.baseURL}/user/getexport`);
  }

  public getCustomerExportFormats(): Observable<any> {
    return this.http.get(`${this.baseURL}/customer/getexport`);
  }

  public getOrderExportFormats(): Observable<any> {
    return this.http.get(`${this.baseURL}/order/getexport`);
  }

  public getRoleExportFormats(): Observable<any> {
    return this.http.get(`${this.baseURL}/role/getexport`);
  }

  public getLicenseExportFormats(): Observable<any> {
    return this.http.get(`${this.baseURL}/v1/license/getexport`);
  }

  // public CreateSmartlockLicense(data:any): Observable<any> {
  //   return this.http.post(`https://qubeapi.com:8089/smartlock/api/1.0/license`, data);
  // }

  public CreateSmartlockLicense(data: any): Observable<any> {
    const url = `${this.getSmartlockBaseURL()}/license`;
    return this.http.post(url, data);
  }

  public CreateSmartlockLicenseV2(data:any): Observable<any> {
    return this.http.post(`${this.baseURL}/smartlock/license`, data);
  }

  // public CreateSmartlockUpgrading(data:any): Observable<any> {
  //   return this.http.post(`https://qubeapi.com:8089/smartlock/api/1.0/upgrading`, data);
  // }

  public CreateSmartlockUpgrading(data: any): Observable<any> {
    const url = `${this.getSmartlockBaseURL()}/upgrading`;
    return this.http.post(url, data);
  }

  public CreateSmartlockUpgradingV2(data:any): Observable<any> {
    return this.http.post(`${this.baseURL}/smartlock/upgrade`, data);
  }

  // public CreateSmartlockActivities(page?: number, type?:string, search?:any, fromDate?:any, toDate?:any, sortDirection?: string): Observable<any> {
  //   const params:any={
  //     page:page,
  //     type:type,
  //     search:search,
  //     start_date:fromDate,
  //     end_date:toDate,
  //     sort_by:sortDirection
  //   }
  //   return this.http.post(`https://qubeapi.com:8089/smartlock/api/1.0/activities`,  params);
  // }

  public CreateSmartlockActivities(
    page?: number,
    type?: string,
    search?: any,
    fromDate?: any,
    toDate?: any,
    sortDirection?: string
  ): Observable<any> {
    const params: any = {
      page: page,
      type: type,
      search: search,
      start_date: fromDate,
      end_date: toDate,
      sort_by: sortDirection
    };
    const url = `${this.getSmartlockBaseURL()}/activities`;
    return this.http.post(url, params);
  }

  public CreateSmartlockActivitiesV2(page?:number,item?:number, type?:string, tabStatus?:any, fromDate?:any, toDate?:any, search?:any, email?:string, sortDirection?: any, smartlockNo?:any, approvalTab?: any): Observable<any> {
    let params:any={
      page:page,
      item_per_page:item,
      type:type,
      view_by_status:tabStatus,
      start_date:fromDate,
      end_date:toDate,
      search:search,
      requester_email:email,
      sort_by:sortDirection,
      smartlock_no:smartlockNo
    }

    if (tabStatus == "V"){
      params = {
        ...params,
        view_by_status: "",
        verified_status: "P"
      }
    }

    if (tabStatus == "A"){
      params = {
        ...params
      }

      if (approvalTab != null){
        switch (approvalTab){
          case 'all':
            params.verified_status = "";
            break;
          default:
            params.view_by_status = approvalTab;
            break;
        }

      }
    }
    return this.http.post(`${this.baseURL}/smartlock/activites`,  params);
  }

  // public CreateSmartlockExport(type?:string, search?:any, fromDate?:any, toDate?:any): Observable<any> {
  //   const params:any={
  //     type:type,
  //     search:search,
  //     start_date:fromDate,
  //     end_date: toDate
  //   }
  //   return this.http.post(`https://qubeapi.com:8089/smartlock/api/1.0/activities/export`,  params, { responseType: 'blob' });
  // }

  public CreateSmartlockExport(
    type?: string,
    search?: any,
    fromDate?: any,
    toDate?: any
  ): Observable<any> {
    const params: any = {
      type: type,
      search: search,
      start_date: fromDate,
      end_date: toDate
    };
    const url = `${this.getSmartlockBaseURL()}/activities/export`;
    return this.http.post(url, params, { responseType: 'blob' });
  }

  public CreateSmartlockExportV2(type?:string, tabStatus?:any, fromDate?:any, toDate?:any, search?:any, email?:string, sortDirection?: any, smartlockNo?:any): Observable<any> {
    const params:any={
      type:type,
      view_by_status:tabStatus,
      start_date:fromDate,
      end_date:toDate,
      search:search,
      requester_email:email,
      sort_by:sortDirection,
      smartlock_no:smartlockNo
    }
    return this.http.post(`${this.baseURL}/smartlock/activites/export`,  params, { responseType: 'blob' });
  }

  // public smartlockHealth(): Observable<any> {
  //   return this.http.get(`https://qubeapi.com:8089/smartlock/healthcheck`);
  // }

  public smartlockHealth(): Observable<any> {
    const healthCheckURL = this.baseURL === this.prodURL
      ? 'https://qubeapi.com/api/central/smartlockv1/healthcheck'
      : `${this.baseURL}/smartlockv1/healthcheck`;
  
    return this.http.get(healthCheckURL);
  }

  public smartlockHealthV2(): Observable<any> {
    return this.http.get(`${this.baseURL}/smartlock/healthcheck`);
  }

  public getListModules(): Observable<any> {
    return this.http.get(`${this.baseURL}/smartlock/module/list`);
  }

  approving(submissionId: string, email: string): Observable<any> {
    const payload = {
      user_email: email,
    };
    return this.http.post(`${this.baseURL}/smartlock/submission/approve/${submissionId}`, payload);
  }
  
  rejecting(data: any): Observable<any> {
    
    const { submissionId, user_email, remark, otherRemark } = data;
  
    const payload = {
      user_email: user_email,
      remark: remark,
      remark_desc: otherRemark
    };
  
    // Make the POST request with dynamic submissionId in the URL
    return this.http.post(`${this.baseURL}/smartlock/submission/reject/${submissionId}`, payload);
  }

  bulkApprovalSubmission(data: any){
    return this.http.post(`${this.baseURL}/smartlock/submission/bulk`, data);
  }
  
  getSmartlockProfile(SmartlockId: string): Observable<any> {
    return this.http.get(`${this.baseURL}/smartlock/account/${SmartlockId}`);
  }

  getSmartlockProfileMain(page?:number, item?:number, search?:any, sortDirection?: any): Observable<any> {
    const params:any={
      page:page,
      item_per_page:item,
      search:search,
      sort_by:sortDirection,
    }

    return this.http.post(`${this.baseURL}/smartlock/account`, params);
  }

  getSetting(type: any){
    let url = this.baseURL;
    switch (type){
      case 'smartlockv2':
        url = url + "/smartlock/setting";
        break;
    }
    return this.http.get(`${url}`);
  }

  updateSetting(type: any, formData: any){
    let url = this.baseURL;
    switch (type){
      case 'smartlockv2':
        url = url + "/smartlock/setting";
        break;
    }
    return this.http.post(`${url}`, formData);
  }

  getSystemActivityLog(search: any, page: any, per_page: any, modules: any[], action: any[], date_from?: any, date_to?: any){

    let data = {
      search: search,
      page: page,
      per_page: per_page,
      module: modules ?? [],
      action: action ?? [],
      date_range: {
        from: date_from ?? null,
        to: date_to ?? null
      }
    }
    return this.http.post(`${this.baseURL}/system-activity-log`, data);

  }

  exportSystemActivityLog(modules: any[], action: any[], date_from?: any, date_to?: any){

    let data = {
      modules: modules ?? [],
      action: action ?? [],
      date_range: {
        from: date_from ?? null,
        to: date_to ?? null
      }
    }
    return this.http.post(`${this.baseURL}/system-activity-log/export`, data, { responseType: 'blob' });
  }

// Qube Connect
  // E-Name Card

  public getNamecardUserList(page:number, search:any, item:any) {
    const params:any = {
      page: page,
      item:item,
      search:search
    };
    return this.http.get(`${this.baseURL}/e-name-cards`, { params });
  }
  public getAllTemplates() {
    return this.http.get(`${this.baseURL}/e-name-card/templates`);
  }
  public getSingleTemplates(templates_id:any) {
    return this.http.get(`${this.baseURL}/e-name-card/templates/${templates_id}`);
  }

  public postUpdateTemplate(templates_id: string, tabs: string, data: any){

    switch (tabs) {
      case 'general':
        //  return this.http.get<any>(`${this.baseURL}/e-name-card/templates/${templates_id}/general`);
        return this.http.post(`${this.baseURL}/e-name-card/templates/${templates_id}/general`, data);
      case 'banner':
        return this.http.post(`${this.baseURL}/e-name-card/templates/${templates_id}/banner`, data);
      case 'layout':
        return this.http.post(`${this.baseURL}/e-name-card/templates/${templates_id}/layout`, data);
      default:
        return this.http.get<any>(`${this.baseURL}/e-name-card/templates/${templates_id}`);
    }
    
  }
  public generateCode(user_id: any) {
    return this.http.post(`${this.baseURL}/e-name-card/regenerate-url`, user_id);
  }
  public getjobTitle() {
    return this.http.get(`${this.baseURL}/user/job-positions`);
  }
  public getNamecardExport() {
    return this.http.get(`${this.baseURL}/e-name-cards/export?format=pdf`);
  }
  public postBannerLinks(templates_id: string, data: any){
      return this.http.post(`${this.baseURL}/e-name-card/templates/${templates_id}/banner-links`, data);
  }

  public getTaggingList(params: any){
    if (params?.status === null){
      delete params.status
    }
    return this.http.get(`${this.baseURL}/tags`, {params});
  }

  public upsertTags(isCreate: boolean, formData: { name: string, description?: string, status?: boolean, id?: string}){
    if (isCreate){
      return this.http.post(`${this.baseURL}/tags`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/tags/${formData.id}`, formData);
    }
  }

  public getTagsDetail(id: any){
    return this.http.get(`${this.baseURL}/tags/${id}`);
  }

  public toggleTagStatus(params: {id: any}){
    return this.http.patch(`${this.baseURL}/tags/${params.id}/toggle-status`, params);
  }


  public tagsDropdown(){
    return this.http.get(`${this.baseURL}/dropdown/tags`);
  }

  public currencyDropdown(){
    return this.http.get(`${this.baseURL}/dropdown/currencies`);
  }

  public addOnDropdown(params: {search: any}){
    if (params.search === ""){
      delete params.search
    }
    return this.http.get(`${this.baseURL}/dropdown/addons`, { params });
  }

  public addOnTemplateDropdown(){
    return this.http.get(`${this.baseURL}/dropdown/addon-templates`);
  }

  
  public brandsDropdown(params: {company_id: any}){
    if (params.company_id === null){
      delete params.company_id
    }
    // if (params.search === null){
    //   delete params.search
    // }
    return this.http.get(`${this.baseURL}/dropdown/brands`, { params });
  }

  public entityDropdown(params: {brand_id: any}){
    if (params.brand_id === null){
      delete params.brand_id
    }
    // if (params.search === null){
    //   delete params.search
    // }
    return this.http.get(`${this.baseURL}/dropdown/legal-entities`, { params });
  }

  public companyContactsDropdown(params: {company_id: any}){
    if (params.company_id === null){
      delete params.company_id
    }
    // if (params.search === null){
    //   delete params.search
    // }
    return this.http.get(`${this.baseURL}/dropdown/company-contacts`, { params });
  }


  public upsertAddOn(isCreate: boolean, formData: { code?: string, description?: string, name?: string, prices?: any[], status?: boolean, tag_ids?: any[], id?: any}){

    if (isCreate){
      return this.http.post(`${this.baseURL}/addons`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/addons/${formData.id}`, formData);
    }

  }

  public getAddOnList(params: { status: any, search: any, page: any, perPage: any, tag_id: any}){
    if (params.status === null){
      delete params.status
    }if (params.tag_id === null){
      delete params.tag_id
    }
    return this.http.get(`${this.baseURL}/addons`, {params});
  }

  public toggleAddOnStatus(params: {id: any}){
    return this.http.patch(`${this.baseURL}/addons/${params.id}/toggle-status`, params);
  }

  public getAddOnDetail(id: any){
    return this.http.get(`${this.baseURL}/addons/${id}`);
  }

  
  public upsertAddOnTemplate(isCreate: boolean, formData: { code?: string, description?: string, name?: string, addons?: any[], status?: boolean, id?: any}){

    if (isCreate){
      return this.http.post(`${this.baseURL}/addon-templates`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/addon-templates/${formData.id}`, formData);
    }
  }

  public getAddOnTemplateList(params: { status: any, search: any, page: any, perPage: any, tag_id: any}){
    if (params.status === null){
      delete params.status
    }if (params.tag_id === null){
      delete params.tag_id
    }
    return this.http.get(`${this.baseURL}/addon-templates`, {params});
  }

  public toggleAddOnTemplateStatus(params: {id: any}){
    return this.http.patch(`${this.baseURL}/addon-templates/${params.id}/toggle-status`, params);
  }

  public getAddOnTemplateDetail(id: any){
    return this.http.get(`${this.baseURL}/addon-templates/${id}`);
  }

  public upsertCompany(isCreate: boolean, formData: { company_code?: any, company_email?: any, notes: any, company_contact?: any, external_code?:any, company_name?: any, status?:boolean, file?:any, id?:any}){

    const fd = new FormData();
    if (formData.file != null){
      fd.append("file", formData.file);
    }
    fd.append("company_code", formData.company_code ?? '');
    fd.append("company_name", formData.company_name ?? '');
    fd.append("company_email", formData.company_email ?? '');
    fd.append("company_contact", formData.company_contact ?? '');
    fd.append("external_code", formData.external_code ?? '');
    fd.append("notes", formData.notes ?? '');
    fd.append("status", formData.status ? "1": "0");
    if (isCreate){
      return this.http.post(`${this.baseURL}/companies`, fd);
    }
    else {
      return this.http.put(`${this.baseURL}/companies/${formData.id}`, fd);
    }
  }

  public getProductComponentList(params: { status: any, search: any}){
    if (params.status === null){
      delete params.status
    }if (params.search === null){
      delete params.search
    }
    return this.http.get(`${this.baseURL}/product-components`, {params});
  }

  
  public upsertProduct(isCreate: boolean, formData: ProductUpsertModel){

    const fd = new FormData();
    if (formData.id != null){
      fd.append("id", formData.id);
    }
    if (formData.icon != null){
      fd.append("icon", formData.icon);
    }
    fd.append("code", formData.code);
    fd.append("name", formData.name);
    fd.append("description", formData.description ?? "");
    fd.append("status", formData.status ? "1" : "0");

    if (formData.addons.length > 0){
      fd.append("addons", JSON.stringify(formData.addons));
    }

    if (formData.components.length > 0){
      fd.append("components", JSON.stringify(formData.components));
    }
    fd.append("prices", JSON.stringify(formData.prices));
    
    if (isCreate){
      return this.http.post(`${this.baseURL}/products/create-full`, fd);
    }
    else {
      return this.http.post(`${this.baseURL}/products/${formData.id}/update-full`, fd);
    }

  }

  public toggleProductStatus(params: {id: any}){
    return this.http.patch(`${this.baseURL}/products/${params.id}/toggle-status`, params);
  }

  public getProductList(params: { status: any, search: any, page: any, perPage: any}){
    if (params.status === null){
      delete params.status
    }
    return this.http.get(`${this.baseURL}/products`, {params});
  }

  public getProductDetail(id: any){
    return this.http.get(`${this.baseURL}/products/${id}`);
  }

  
  public getCompanyList(params: GetCompanyListModel){
    if (params.status === 'all'){
      delete params.status
    }
    return this.http.post(`${this.baseURL}/companies/index`, params);
  }

  public getCompanyDetail(id: any){
    return this.http.get(`${this.baseURL}/companies/${id}`);
  }
  
  public deleteCompany(id: any){
    return this.http.delete(`${this.baseURL}/companies/${id}`);
  }

  public getLicenseListV2(data: GetLicenseListModel){
    const params: any = {
      ...data
    }
    if (params.status === 'all'){
      delete params.status
    }
    return this.http.get(`${this.baseURL}/v2/license/index`, {params});
  }

  
  public toggleComponentStatus(params: {id: any}){
    return this.http.patch(`${this.baseURL}/product-components/${params.id}/toggle-status`, params);
  }

  
  public getComponentList(params: { status: any, search: any, page: any, perPage: any, tag_id: any}){
    if (params.status === null){
      delete params.status
    }if (params.tag_id === null){
      delete params.tag_id
    }
    return this.http.get(`${this.baseURL}/product-components`, {params});
  }

  public upsertComponent(isCreate: boolean, formData: ComponentUpsertModel){

    if (isCreate){
      return this.http.post(`${this.baseURL}/product-components`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/product-components/${formData.id}`, formData);
    }
  }

  public getComponentDetail(id: any){
    return this.http.get(`${this.baseURL}/product-components/${id}`);
  }

  
  public getCompanyContactList(params: GetCompanyDatatableListModel){
    return this.http.post(`${this.baseURL}/companies/${params.id}/contacts/index`, params);
  }

  public getCompanyContactDetails(company_id: string, contact_id: string){
    return this.http.get(`${this.baseURL}/companies/${company_id}/contacts/${contact_id}`);
  }

  
  public upsertCompanyContacts(isCreate: boolean, formData: UpsertCompanyContactsModel){
    
    if (isCreate){
      return this.http.post(`${this.baseURL}/companies/${formData.company_id}/contacts`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/companies/${formData.company_id}/contacts/${formData.id}`, formData);
    }
  }

  
  public deleteCompanyContacts(company_id: string, contact_id: string){
    return this.http.delete(`${this.baseURL}/companies/${company_id}/contacts/${contact_id}`);
  }

  public exportCompanyContacts(company_id: string){
    return this.http.post(`${this.baseURL}/companies/${company_id}/contacts/export`, {}, { responseType: 'blob' });
  }

  public getCompanyBrandList(params: GetCompanyDatatableListModel){
    return this.http.post(`${this.baseURL}/companies/${params.id}/brands/index`, params);
  }

  public getCompanyBrandDetails(company_id: string, brand_id: string){
    return this.http.get(`${this.baseURL}/companies/${company_id}/brands/${brand_id}`);
  }

  public upsertCompanyBrands(isCreate: boolean, formData: UpsertCompanyBrandsModel){
    
    if (isCreate){
      return this.http.post(`${this.baseURL}/companies/${formData.company_id}/brands`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/companies/${formData.company_id}/brands/${formData.id}`, formData);
    }
  }

  public deleteCompanyBrands(company_id: string, brand_id: string){
    return this.http.delete(`${this.baseURL}/companies/${company_id}/brands/${brand_id}`);
  }
  public exportCompanyBrands(company_id: string){
    return this.http.post(`${this.baseURL}/companies/${company_id}/brands/export`, {}, { responseType: 'blob' });
  }

  public getCompanyEntityList(params: GetCompanyDatatableListModel){
    return this.http.post(`${this.baseURL}/companies/${params.id}/legal-entities/index`, params);
  }

  public getCompanyEntityDetails(company_id: string, entities_id: string){
    return this.http.get(`${this.baseURL}/companies/${company_id}/legal-entities/${entities_id}`);
  }

  public upsertCompanyEntity(isCreate: boolean, formData: UpsertCompanyBrandsModel){
    
    if (isCreate){
      return this.http.post(`${this.baseURL}/companies/${formData.company_id}/legal-entities`, formData);
    }
    else {
      return this.http.put(`${this.baseURL}/companies/${formData.company_id}/legal-entities/${formData.id}`, formData);
    }
  }

  public getInitCompanyEntitiy(company_id: string, country_id: string | null){
    let params: any = {
      country_id
    }

    if (country_id == null){
      delete params.country_id
    }
    return this.http.get(`${this.baseURL}/companies/${company_id}/legal-entities`, { params });
  }

  
  public deleteCompanyEntity(company_id: string, entity_id: string){
    return this.http.delete(`${this.baseURL}/companies/${company_id}/legal-entities/${entity_id}`);
  }

  public exportCompanyEntity(company_id: string){
    return this.http.post(`${this.baseURL}/companies/${company_id}/legal-entities/export`, {}, { responseType: 'blob' });
  }

  public getCompanyLicenseList(params: GetCompanyDatatableListModel){
    if (params.status == ""){
      delete params.status
    }
    return this.http.post(`${this.baseURL}/companies/${params.id}/licenses/index`, params);
  }

  public exportCompanyLicenses(company_id: string){
    return this.http.post(`${this.baseURL}/companies/${company_id}/licenses/export`, {}, { responseType: 'blob' });
  }

  
  public getCompanyActivityLog(id: string, formData: any){
    return this.http.post(`${this.baseURL}/companies/${id}/activity-logs/index`, formData);
  }

  public exportCompanyActivityLog(id: string, formData: any){
    return this.http.post(`${this.baseURL}/companies/${id}/activity-logs/index`, formData, { responseType: 'blob' });
  }

  public checkLicenseDomain(domain_name : string){
    let params: any = {
      domain_name 
    }
    return this.http.get(`${this.baseURL}/v2/license/domain`, { params });

  }

  public postCreateLicense(company_id: any, licenseList: any[]){

    let params = {
      company_id: company_id,
      licenses: licenseList
    }
    return this.http.post(`${this.baseURL}/v2/license/store`, params);
  }

  public getLicenseExportFormat(){
    return this.http.get(`${this.baseURL}/v2/license/getexport`);

  }

  
  public getOrderListV2(data: GetOrderListModel){

    const params: any = {
      ...data
    }

    if (params.status === 'all'){
      delete params.status
    }
    
    return this.http.get<any>(`${this.baseURL}/v2/orders`, { params })
  }

  
  public getOrderDetails(id:any){
    return this.http.get(`${this.baseURL}/v2/orders/${id}`);

  }

  
  public printOrderV2(id: any) {
    
    // const params = new HttpParams().set('order_id', id);
    const headers = new HttpHeaders({
      'responseType': 'blob',
      'Content-Type': 'application/pdf',
    });

    return this.http.get(`${this.baseURL}/v2/orders/${id}/print`,{ headers, responseType: 'blob' });
  }

  public getLicenseDetails(id: any){

    const params: any = {
      license_id: id
    }
    
    return this.http.get<any>(`${this.baseURL}/v2/license/show`, { params })
  }

  public updateLicenseSettings(type: any, data: any){
    switch(type){
      case 'offline_grace':
      case 'online_grace':
        return this.http.post(`${this.baseURL}/v2/license/grace`, data);
      default:
        return EMPTY;
    }
  }

  
  public updateOrderStatus(data: {file: File | null, status: string, order_id: any, invoice_no: string | null, remark: string | null}){
    const fd = new FormData();
    fd.append('status', data?.status);
    fd.append('invoice_no', data?.invoice_no ?? '');
    fd.append('remark', data?.remark ?? '');
    if (data.file !== null){
    fd.append('file', data?.file);
    }

    return this.http.patch(`${this.baseURL}/v2/orders/${data.order_id}/status`, fd);
  }

  
  public getEditLicenseStatus(license_id:any){
    
    const params: any = {
      license_id
    }
    return this.http.get(`${this.baseURL}/v2/license/edit`, { params });
  }

  public revokeLicenseV2(license_id: any){

    const params: any = {
      license_id
    }
    return this.http.post(`${this.baseURL}/v2/license/revoke`, params);

  }

  public toggleSuspendLicenseV2(license_id: any){

    const params: any = {
      license_id
    }
    return this.http.post(`${this.baseURL}/v2/license/suspend`, params);

  }

  public updateLicenseV2(formData: any){
    return this.http.post(`${this.baseURL}/v2/license/update`, formData);

  }

  
  public getProductProfiles(filterData: any){
    
    const params: any = {
      ...filterData
    }

    const queryParams = Object.fromEntries(
      Object.entries(params)
        .filter(([_, value]) => value != null && value != '')
    ) as Record<string, string | number | boolean>;

    
    return this.http.get(`${this.baseURL}/products/list/profiles`, {params: queryParams});
  }

  public getProductProfileDetails(id: any){
    return this.http.get(`${this.baseURL}/products/${id}/profile`);
  }

  public updateProductProfileDetails(id: any, formData: any){
    return this.http.put(`${this.baseURL}/products/${id}/profile`, formData);
  }
}



